/* globals google */

'use strict';

const geocode = require('../components/deliveryModal/geocode');
const googleMapsUtil = require('../components/deliveryModal/googleMapsUtil');
const { haversine } = require('../util/haversine');
const analyticsHelper = require('../util/analyticsHelper');

const map_config = {
    //Guadalajara's coordinates
    initialPosition: {
        lat: 20.661727,
        lng: -103.315426
    },
    markerImg: {
        scaledSize: {
            x: 30,
            y: 30
        },
        origin: {
            x: 0,
            y: 0
        },
        anchor: {
            x: 15,
            y: 30
        }
    },
    pegmanImg: {
        scaledSize: {
            x: 40,
            y: 40
        },
        origin: {
            x: 0,
            y: 0
        },
        anchor: {
            x: 20,
            y: 40
        }
    },
    circle: {
        strokeColor: '#0277BD',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#0277BD',
        fillOpacity: 0
    },
    shadowMarker: {
        icon: {
            scale: 15,
            fillColor: "#FF0000",
            fillOpacity: 0.2,
            strokeWeight: 0
        }
    },
    redMarker: {
        icon: {
            scale: 5,
            fillColor: "#FF0000",
            fillOpacity: 1,
            strokeWeight: 1,
            strokeColor: "#FFFFFF"
        }
    },
    zoom: 16
}

let $selectedLatitude = map_config.initialPosition.lat;
let $selectedLongitude = map_config.initialPosition.lng;
let $globalSortedStores = [];
let hours24Msg = '';
let scheduleFirstMsg = '';
let scheduleSecondMsg = '';
const TIME_REGEX = /^\d{1,2}:\d{2}:\d{2}$/;
let $postalCodeInput = null;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
    var map;
    const isMobile = $('.ua-mobile').length > 0;

    var latlng = new google.maps.LatLng(
        $selectedLatitude || map_config.initialPosition.lat,
        $selectedLongitude || map_config.initialPosition.lng
    );

    var mapOptions = {
        scrollwheel: false,
        zoom: 16,
        streetViewControl: false,
        center: latlng,
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
        }
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);

    var bounds = new google.maps.LatLngBounds();

    var customPinIcon = $('#store-postal-code').data('pin-icon');
    var pegmanIcon = $('#store-postal-code').data('pegman-icon');
    var radiusKm = parseFloat($('#store-postal-code').data('radius')) || 0;
    var radiusMeters = radiusKm * 1000;

    var markerImg = {
        url: customPinIcon,
        scaledSize: new google.maps.Size(map_config.markerImg.scaledSize.x, map_config.markerImg.scaledSize.y),
        origin: new google.maps.Point(map_config.markerImg.origin.x, map_config.markerImg.origin.y),
        anchor: new google.maps.Point(map_config.markerImg.anchor.x, map_config.markerImg.anchor.y)
    };

    var circle = new google.maps.Circle({
        strokeColor: map_config.circle.strokeColor,
        strokeOpacity: map_config.circle.strokeOpacity,
        strokeWeight: map_config.circle.strokeWeight,
        fillColor: map_config.circle.fillColor,
        fillOpacity: map_config.circle.fillOpacity,
        map: map,
        center: latlng,
        radius: radiusMeters
    });

    if (!isMobile) {
        var pegmanImg = {
            url: pegmanIcon,
            scaledSize: new google.maps.Size(map_config.pegmanImg.scaledSize.x, map_config.pegmanImg.scaledSize.y),
            origin: new google.maps.Point(map_config.pegmanImg.origin.x, map_config.pegmanImg.origin.y),
            anchor: new google.maps.Point(map_config.pegmanImg.anchor.x, map_config.pegmanImg.anchor.y)
        };

        var pegmanMarker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: pegmanImg,
            zIndex: 999,
            draggable: true
        });

        pegmanMarker.addListener("dragend", function (event) {
            var newLatLng = event.latLng;
            $selectedLatitude = newLatLng.lat();
            $selectedLongitude = newLatLng.lng();
            map.setCenter(newLatLng);
            circle.setCenter(newLatLng);
            searchCloseStores($selectedLatitude, $selectedLongitude);
        });
    } else{
        var shadowMarker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: map_config.shadowMarker.icon.scale,
                fillColor: map_config.shadowMarker.icon.fillColor,
                fillOpacity: map_config.shadowMarker.icon.fillOpacity,
                strokeWeight: map_config.shadowMarker.icon.strokeWeight
            },
            zIndex: 998
        });

        var redMarker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: map_config.redMarker.icon.scale,
                fillColor: map_config.redMarker.icon.fillColor,
                fillOpacity: map_config.redMarker.icon.fillOpacity,
                strokeWeight: map_config.redMarker.icon.strokeWeight,
                strokeColor: map_config.redMarker.icon.strokeColor
            },
            zIndex: 999
        });

    }

    $globalSortedStores.forEach(item => {
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: markerImg,
            zIndex: 998
        });

        const storeData = JSON.stringify(item);
        marker.set("storeData", storeData);

        marker.addListener('click', function () {
            try {
                const parsedStoreData = JSON.parse(marker.get("storeData"));
                renderStorePopin(parsedStoreData);
                openStoreLocatorPopin();
            } catch (error) {
                console.error('Error al parsear los datos de la tienda:', error);
            }
        });

        bounds.extend(marker.position);
    });


    if ($globalSortedStores.length !== 0) {
        map.fitBounds(bounds);
        bounds.union(circle.getBounds());
    }

    var listener = google.maps.event.addListener(map, "idle", function() {
        if (map.getZoom() > map_config.zoom) map.setZoom(map_config.zoom);
        google.maps.event.removeListener(listener);
    });
}

/**
 * Formats the store hours from opening and closing times.
 *
 * @param {string} openingTime - The opening time in the format HH:MM.
 * @param {string} closingTime - The closing time in the format HH:MM.
 * @returns {string} - The formatted store hours or an error message if the times are invalid.
 * @throws {Error} - Throws an error if the opening or closing times are not defined or not in the correct format.
 */
function formatStoreHours(openingTime, closingTime) {
    try {
        if (!openingTime || !closingTime) {
            throw new Error('Opening and closing times must be defined.');
        }

        if (!TIME_REGEX.test(openingTime) || !TIME_REGEX.test(closingTime)) {
            throw new Error('Opening and closing times must be in the format HH:MM.');
        }

        openingTime = openingTime.split(':').slice(0, 2).join(':');
        closingTime = closingTime.split(':').slice(0, 2).join(':');

        const [openHour, openMinute] = openingTime.split(':').map(Number);
        const [closeHour, closeMinute] = closingTime.split(':').map(Number);

        const openingDate = new Date(0, 0, 0, openHour, openMinute);
        const closingDate = new Date(0, 0, 0, closeHour, closeMinute);
        let hoursOpen = (closingDate - openingDate) / 1000 / 60 / 60;

        if (hoursOpen < 0) {
            hoursOpen += 24;
        }

        const openPeriod = openHour >= 12 ? 'pm' : 'am';
        const closePeriod = closeHour >= 12 ? 'pm' : 'am';
        const formattedOpening = `${((openHour + 11) % 12 + 1)}:${openMinute.toString().padStart(2, '0')}${openPeriod}`;
        const formattedClosing = `${((closeHour + 11) % 12 + 1)}:${closeMinute.toString().padStart(2, '0')}${closePeriod}`;
        const $inputElement = $('#store-postal-code');
        hours24Msg = $inputElement.data('24-hours-msg');
        scheduleFirstMsg = $inputElement.data('schedule-first-msg');
        scheduleSecondMsg = $inputElement.data('schedule-second-msg');

        if ((openingTime === "0:00" || openingTime === "00:00") && (closingTime === "23:59" || closingTime === "24:00")) {
            return hours24Msg;
        } else {
            return `${scheduleFirstMsg} ${formattedOpening} ${scheduleSecondMsg} ${formattedClosing}`;
        }
    } catch (error) {
        console.error('Error formatting store hours:', error);
        return '';
    }
}

/**
 * Processes store data by calculating the distance from a selected location and formatting store hours.
 *
 * @param {Object} data - The store data object where keys are store IDs and values are store details.
 * @param {number} selectedLatitude - The latitude of the selected location.
 * @param {number} selectedLongitude - The longitude of the selected location.
 * @returns {Array} An array of store objects with calculated distances and formatted schedules, sorted by distance.
 */
function processStoreData(data, selectedLatitude, selectedLongitude) {
    const stores = Object.keys(data).filter(key => !isNaN(parseInt(key))).map(key => data[key]);

    stores.forEach(store => {
        store.distance = haversine(selectedLatitude, selectedLongitude, store.latitude, store.longitude).toFixed(1);
        store.schedule = formatStoreHours(store.openingTime, store.closingTime);
    });

    stores.sort((a, b) => a.distance - b.distance);

    return stores;
}

/**
 * Renders the store results on the page.
 *
 * @param {Array} sortedStores - An array of store objects, each containing store details such as name, address, schedule, distance, etc.
 * @param {boolean} isMobile - A boolean indicating whether the current view is on a mobile device.
 *
 * @property {string} sortedStores[].name - The name of the store.
 * @property {string} sortedStores[].address1 - The first line of the store's address.
 * @property {string} sortedStores[].postalCode - The postal code of the store.
 * @property {string} sortedStores[].city - The city where the store is located.
 * @property {string} sortedStores[].state - The state where the store is located.
 * @property {boolean} sortedStores[].showManualSchedule - A flag indicating whether to show manual schedule text.
 * @property {string} sortedStores[].manualScheduleText - The manual schedule text to display if showManualSchedule is true.
 * @property {string} sortedStores[].schedule - The store's schedule.
 * @property {number} sortedStores[].distance - The distance to the store in kilometers.
 * @property {number} sortedStores[].latitude - The latitude of the store.
 * @property {number} sortedStores[].longitude - The longitude of the store.
 *
 * @property {string} $container.data('first-msg') - The first part of the message to display with the store count.
 * @property {string} $container.data('second-msg') - The second part of the message to display with the store count.
 * @property {string} $container.data('show-map-icon-url') - The URL of the icon to show the map.
 * @property {string} $container.data('show-map-icon-alt') - The alt text for the map icon.
 * @property {string} $container.data('show-list-icon-url') - The URL of the icon to show the store list.
 * @property {string} $container.data('show-list-icon-alt') - The alt text for the store list icon.
 * @property {string} $container.data('route-button-msg') - The message to display on the route button.
 */
function renderStoreResults(sortedStores, isMobile) {
    const $container = $('.stores-results-container');
    const $mapContainer = $('.store-locator-map-container');
    $container.empty();
    $mapContainer.children().not('.map-canvas').remove();

    const $firstMsgQty = $container.data('first-msg');
    const $secondMsgQty = $container.data('second-msg');
    const showMapIcon = $container.data('show-map-icon-url');
    const showMapIconAlt = $container.data('show-map-icon-alt');
    const showStoreListIcon = $container.data('show-list-icon-url');
    const showStoreListIconAlt = $container.data('show-list-icon-alt');
    const routeButtonMsg = $container.data('route-button-msg');

    let $storeResults = `
        <div class="stores-count-container">
            <div class="stores-count-title">
                <span class="stores-count">${sortedStores.length} ${$firstMsgQty}</span>&nbsp;
                <span class="stores-count-msg">${$secondMsgQty}</span>
            </div>`;

    if (sortedStores.length > 0) {
        $storeResults += `
            <div class="store-show-icon">
                <img class="d-sm-block d-md-none show-map" src="${showMapIcon}" alt="${showMapIconAlt}">
                <img class="d-sm-none d-md-none show-store-list" src="${showStoreListIcon}" alt="${showStoreListIconAlt}">
            </div>`;
    }

    $storeResults += `</div>`;

    const $storeListContainer = $('<div class="store-list-container"></div>');

    sortedStores.forEach(store => {
        const address = [store.address1, store.postalCode, store.city, store.stateCode]
                        .filter(part => part)
                        .join(', ');

        const storeData = JSON.stringify(store);

        const scheduleContent = store.showManualSchedule ? store.manualScheduleText : `<div class="store-schedule">${store.schedule}</div>`;

        const $storeInfo = `
            <div class="store-info" data-store-info='${storeData}'>
                <div class="store-name">${store.name}</div>
                <div class="store-address">${address}</div>
                <div class="store-schedule-distance-container">
                    ${scheduleContent}
                    <div class="store-distance">Distancia: ${store.distance}km</div>
                </div>
            </div>`;

        const $getDirections = `
            ${isMobile ? `<div class="get-directions-container">
                <a class="btn btn-outline-primary get-directions" href="https://www.google.com/maps/dir/?api=1&origin=${$selectedLatitude},${$selectedLongitude}&destination=${store.latitude},${store.longitude}" target="_blank">${routeButtonMsg}</a>
            </div>` : ''}`;

        const $storeItemContainer = `
            <div class="store-item-container">
                ${$storeInfo}
                ${$getDirections}
            </div>`;

        $storeListContainer.append($storeItemContainer);
    });

    if (sortedStores.length === 0 || !isMobile) {
        $container.append($storeResults);
        $container.append($storeListContainer);
    } else {
        const $wrappedContent = $('<div class="stores-results-container"></div>').append($storeResults).append($storeListContainer);
        $mapContainer.prepend($wrappedContent);
    }
}

/**
 * Returns a promise that resolves to a valid image URL.
 * It first tries to load the primary URL, and if it fails, it tries to load the fallback URL.
 *
 * @param {string} primaryUrl - The primary image URL to try to load.
 * @param {string} fallbackUrl - The fallback image URL to use if the primary URL fails to load.
 * @returns {Promise<string>} A promise that resolves to the valid image URL.
 */
function getValidImageUrl(primaryUrl, fallbackUrl) {
    return new Promise((resolve) => {
        const img = new Image();

        img.onload = function() {
            resolve(primaryUrl);
        };

        img.onerror = function() {
            const fallbackImg = new Image();

            fallbackImg.onload = function() {
                resolve(fallbackUrl);
            };

            fallbackImg.onerror = function() {
                resolve(fallbackUrl);
            };

            fallbackImg.src = fallbackUrl;
        };

        img.src = primaryUrl;
    });
}


/**
 * Renders a popin with store information.
 *
 * @param {Object} store - The store object containing information to display.
 * @param {string} store.name - The name of the store.
 * @param {string} store.abbreviation - The abbreviation of the store.
 * @param {string} store.address1 - The first line of the store's address.
 * @param {string} store.postalCode - The postal code of the store.
 * @param {string} store.city - The city where the store is located.
 * @param {string} store.state - The state where the store is located.
 * @param {boolean} store.showManualSchedule - Flag indicating if manual schedule should be shown.
 * @param {string} store.manualScheduleText - The manual schedule text.
 * @param {string} store.schedule - The store's schedule.
 * @param {boolean} store.isMinilabEnabled - Flag indicating if the minilab service is enabled.
 * @param {boolean} store.isPickupEnabled - Flag indicating if the pickup service is enabled.
 * @param {boolean} store.isLockerEnabled - Flag indicating if the locker service is enabled.
 * @param {boolean} store.hasDoctorOffice - Flag indicating if the store has a doctor office.
 * @param {string} store.doctorOfficeSchedule - The schedule of the doctor office.
 * @param {boolean} store.isDermoBranch - Flag indicating if the store is a dermo branch.
 * @param {number} store.latitude - The latitude of the store's location.
 * @param {number} store.longitude - The longitude of the store's location.
 */
function renderStorePopin(store) {
    const $container = $('.store-popin-container');
    $container.empty();
    const photoIcon = $container.data('photo-icon');
    const lockerIcon = $container.data('locker-icon');
    const medicalIcon = $container.data('medical-icon');
    const dermoIcon = $container.data('dermo-icon');
    const photoService = $container.data('photo-service');
    const lockerService = $container.data('locker-service');
    const medicalService = $container.data('medical-service');
    const dermoService = $container.data('dermo-service');
    const photoServiceSubtitle = $container.data('photo-service-subtitle');
    const lockerServiceSubtitle = $container.data('locker-service-subtitle');
    const dermoServiceSubtitle = $container.data('dermo-service-subtitle');
    const closeIcon = $container.data('close-icon');
    const routeButtonMsg = $container.data('route-button-msg');
    const storeImageUrlPattern = $container.data('url-image-pattern');
    const storeDefaultImageUrl = $container.data('url-default-img');
    const storeImageUrl = storeImageUrlPattern.replace('%abbreviation%', store.abbreviation);

    getValidImageUrl(storeImageUrl, storeDefaultImageUrl).then(finalImageUrl => {
        const address = [store.address1, store.postalCode, store.city, store.stateCode]
            .filter(part => part)
            .join(', ');

        const scheduleContent = store.showManualSchedule
            ? store.manualScheduleText
            : `<div class="store-schedule">${store.schedule}</div>`;

        const $storeInfoPopinContainer = $('<div class="store-info-popin-container"></div>');
        const $storeInfo = `
            <div class="store-info-popin">
                <div class="store-header">
                    <div class="store-name">${store.name}</div>
                    <button class="bottom-sheet-close close" data-dismiss="modal">
                        <img class="close-icon" src="${closeIcon}" alt="Cerrar">
                    </button>
                </div>
                <div class="store-image-container">
                    <img class="store-image" src="${finalImageUrl}" alt="${store.name}">
                </div>
                <div class="store-address">
                    <div class="address-label">Dirección:</div>
                    <div class="address">${address}</div>
                </div>
                <div class="store-services">
                    <div class="service-label">Servicios:</div>
                    ${store.isMinilabEnabled ? `
                        <div class="service">
                            <img src="${photoIcon}" alt="Fotografía">
                            <div class="service-details">
                                <div class="service-title">${photoService}</div>
                                <div class="service-subtitle">${photoServiceSubtitle}</div>
                            </div>
                        </div>` : ''}
                    ${store.isPickupEnabled || store.isLockerEnabled ? `
                        <div class="service">
                            <img src="${lockerIcon}" alt="Locker">
                            <div class="service-details">
                                <div class="service-title">${lockerService}</div>
                                <div class="service-subtitle">${lockerServiceSubtitle}</div>
                            </div>
                        </div>` : ''}
                    ${store.hasDoctorOffice ? `
                        <div class="service">
                            <img src="${medicalIcon}" alt="Consultorio médico">
                            <div class="service-details">
                                <div class="service-title">${medicalService}</div>
                                <div class="service-subtitle">${store.doctorOfficeSchedule}</div>
                            </div>
                        </div>` : ''}
                    ${store.isDermoBranch ? `
                        <div class="service">
                            <img src="${dermoIcon}" alt="Dermo">
                            <div class="service-details">
                                <div class="service-title">${dermoService}</div>
                                <div class="service-subtitle">${dermoServiceSubtitle}</div>
                            </div>
                        </div>` : ''}
                </div>
                <div class="store-schedule-container">
                    <div class="schedule-label">Horario:</div>
                    ${scheduleContent}
                </div>
                <div class="get-directions-container">
                    <a class="btn btn-outline-primary get-directions"
                       href="https://www.google.com/maps/dir/?api=1&origin=${$selectedLatitude},${$selectedLongitude}&destination=${store.latitude},${store.longitude}"
                       target="_blank">${routeButtonMsg}</a>
                </div>
            </div>`;

        $storeInfoPopinContainer.append($storeInfo);
        $container.append($storeInfoPopinContainer);
    });
}


/**
 * Searches for stores close to the given latitude and longitude.
 *
 * @param {number} latitude - The latitude of the location to search near.
 * @param {number} longitude - The longitude of the location to search near.
 */
function searchCloseStores(latitude, longitude) {
    const $mapDiv = $('.map-canvas');
    const isMobile = $('.ua-mobile').length > 0;
    if (!latitude || !longitude) {
        return;
    }

    $.ajax({
        url: $('.store-locator .store-postal-code').attr('data-url'),
        type: 'get',
        dataType: 'json',
        data: {
            latitude: latitude,
            longitude: longitude
        },
        success: function (data) {
            $globalSortedStores = processStoreData(data, $selectedLatitude, $selectedLongitude);
            if (isMobile && $globalSortedStores.length > 0) {
                $mapDiv.hide();
            } else {
                $mapDiv.show();
            }
            renderStoreResults($globalSortedStores, isMobile);
            $('.current-location-container').css('top', '110px');
            if ($mapDiv.data('has-google-api')) {
                maps();
            } else {
                $('.store-locator-no-api-key').show();
            }
        },
        error: function (err) {
            console.error("Error in searchCloseStores function");
        }
    });
}

/**
 * Reverse geocodes the given latitude and longitude, updates the store postal code input field,
 * and searches for nearby stores.
 *
 * @param {number} lat - The latitude to reverse geocode.
 * @param {number} lng - The longitude to reverse geocode.
 */
function reverseGeocodeAndUpdate(lat, lng) {
    var geocoder = new google.maps.Geocoder();
    var latlng = {lat: lat, lng: lng};
    var geocoderErrorMsg = $('.detect-location').data('error');
    var inverseGeocodingError= $('.detect-location').data('iverse-geocoding-error');

    geocoder.geocode({'location': latlng}, function(results, status) {
        if (status === 'OK') {
            if (results[0]) {
                $('.store-postal-code').val(results[0].formatted_address);
                var contenedorPostalCode = $('.input-group.form-group').has('.store-postal-code');
                contenedorPostalCode.addClass('filled focus');

                searchCloseStores(lat, lng);

            } else {
                console.error(geocoderErrorMsg);
            }
        } else {
            console.error(inverseGeocodingError + status);
        }
    });
}


/**
 * Handles the change event for the autocomplete input.
 * Retrieves the selected place's latitude and longitude from the autocomplete object,
 * and triggers a search for nearby stores based on these coordinates.
 *
 * @param {Object} autocomplete - The autocomplete object containing the selected place.
 */
function handleAutocompleteChange (autocomplete) {
    closeStorePopin();
    const place = autocomplete.getPlace();

    if (place.geometry) {
        $selectedLatitude = place.geometry.location.lat();
        $selectedLongitude = place.geometry.location.lng();
        searchCloseStores($selectedLatitude, $selectedLongitude);
    }
}

/**
 * Initializes the autocomplete functionality for the store locator.
 * Loads the Google Maps script and sets up the autocomplete for the postal code input field.
 *
 * @function
 * @returns {void}
 */
function initAutocomplete() {
    geocode.initAutocomplete($('.store-locator #store-postal-code'), handleAutocompleteChange);
}

/**
 * Toggles the visibility of the map and store list elements on the page.
 *
 * This function hides the store list container and shows the map canvas.
 * It also updates the visibility classes for the "show map" and "show store list" buttons.
 */
function showMap() {
    $('.show-map').removeClass('d-sm-block').addClass('d-sm-none');
    $('.store-list-container').hide();
    $('.map-canvas').show();
    $('.show-store-list').removeClass('d-sm-none').addClass('d-sm-block');
}

/**
 * Toggles the visibility of the store list and map canvas elements.
 *
 * This function performs the following actions:
 * - Hides the store list button by removing the 'd-sm-block' class and adding the 'd-sm-none' class.
 * - Hides the map canvas element.
 * - Shows the store list container.
 * - Shows the map button by removing the 'd-sm-none' class and adding the 'd-sm-block' class.
 */
function showStoreList() {
    $('.show-store-list').removeClass('d-sm-block').addClass('d-sm-none');
    $('.map-canvas').hide();
    $('.store-list-container').show();
    $('.show-map').removeClass('d-sm-none').addClass('d-sm-block');
}

/**
 * Opens the store locator popin.
 * If the user is on a mobile device, it triggers an event to open a bottom sheet.
 * Otherwise, it shows a modal dialog.
 */
function openStoreLocatorPopin() {
    const isMobile = $('.ua-mobile').length > 0;
    if (isMobile) {
        $(document).trigger('openBottomSheetRequest', { targetId: '#storeLocatorPopin' });
    }
    else {
        $('.store-popin-container').removeClass('d-none');
    }
}

/**
 * Handles the click event on a store information element.
 *
 * This function performs the following actions:
 * 1. Renders the store popin with the store information data.
 * 2. Opens the store locator popin.
 * 3. Removes the 'selected' class from all store item containers.
 * 4. Adds the 'selected' class to the closest store item container of the clicked element.
 *
 */
function handlerStoreInfoClick() {
    closeStorePopin();
    renderStorePopin($(this).data('store-info'));
    openStoreLocatorPopin();
    $('.store-item-container').removeClass('selected');
    $(this).closest('.store-item-container').addClass('selected');
}

/**
 * Handles the click event on the banner and triggers a Google Analytics event.
 *
 * This function fires a 'view_promotion' event using the analyticsHelper utility
 */
function handleBannerClick() {
    analyticsHelper.trackEvent('view_promotion');
}
/**
 * Handles Enter key press on the postal code input.
 * Triggers Google Places Autocomplete and selects the first prediction,
 * then updates coordinates and initiates store search.
 *
 * @param {KeyboardEvent} e - The keydown event object.
 * @returns {boolean} Always returns false to prevent default form behavior.
 */

function handlePostalCodeEnter(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
        closeStorePopin();
        e.preventDefault();
        e.stopPropagation();

        const inputValue = $(this).val().trim();

        if (!inputValue) {
            return false;
        }

        const autocompleteService = new google.maps.places.AutocompleteService();
        const placesService = new google.maps.places.PlacesService(document.createElement('div'));

        autocompleteService.getPlacePredictions({
            input: inputValue,
            location: new google.maps.LatLng(
                map_config.initialPosition.lat,
                map_config.initialPosition.lng
            ),
            radius: $postalCodeInput.attr('data-radius')
            },(predictions, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length > 0) {
                    const firstPrediction = predictions[0];

                    placesService.getDetails(
                        {
                            placeId: firstPrediction.place_id
                        },
                        (place, status) => {
                            if (status === google.maps.places.PlacesServiceStatus.OK && place.geometry) {
                                $postalCodeInput.val(firstPrediction.description);
                                $selectedLatitude = place.geometry.location.lat();
                                $selectedLongitude = place.geometry.location.lng();
                                searchCloseStores($selectedLatitude, $selectedLongitude);
                            }
                        }
                    );
                }
            }
        );

        return false;
    }
}

function closeStorePopin() {
    const isMobile = $('.ua-mobile').length > 0;
    if (!isMobile) {
        $('.store-popin-container.desktop').addClass('d-none');
    }
}


module.exports = {
    init: function () {
        googleMapsUtil.loadScript().then(() => {
            if ($('.map-canvas').data('has-google-api')) {
                maps();
            }
            initAutocomplete();
        })

        searchCloseStores($selectedLatitude, $selectedLongitude);

        $(document).on('click', '.show-map', showMap);

        $(document).on('click', '.show-store-list', showStoreList);

        $(document).on('click', '.store-info', handlerStoreInfoClick);

        $(document).on('click', '.store-locator-banner-container', handleBannerClick);

        $(document).on('click', '.store-popin-container.desktop .store-info-popin-container .close', closeStorePopin);

        $postalCodeInput = $('.store-postal-code').first();

        $(document).on('submit', '.store-locator', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            closeStorePopin();
            return false;
        });

        $(document).on('keydown', '.store-postal-code', handlePostalCodeEnter);

    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.results').data('radius');
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);

                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        $selectedLatitude = position.coords.latitude;
                        $selectedLongitude = position.coords.longitude;
                        searchCloseStores($selectedLatitude, $selectedLongitude);
                        reverseGeocodeAndUpdate($selectedLatitude, $selectedLongitude);
                        $('.select-store').prop('disabled', true);
                    }
                });
            });
        });
    },

    clearZipCodeInput: function () {
        $(document).on('click', '.store-locator .clear-icon', function() {
            const $input = $(this).siblings('input.store-postal-code');
            $input.val('');
            $input.focus();
        });
    }
};
